


















































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import alatReuseStore from "@/store/modules/AlatReuseStore";
import Service from "@/services/AlatReuseService";
import { storePasien } from "@/store/modules/pasien";
import http from "@/axios/http-common";
import { METODE_STERILISASI, REUSE_STATUS_META } from "@/constants/alatReuseOptions";
import {
  CanReuseResponse,
  MasterAlatReuse,
  PenggunaanAlatReuse
} from "@/types/alat_reuse";

@Component
export default class PenggunaanAlatReuseRanapTab extends Vue {
  @Prop() register!: number;
  @Prop() rm!: number | string;
  @Prop({ default: false }) isActive!: boolean;

  dialog = false;
  deleteDialog = false;
  saving = false;
  editingId: number | null = null;
  toDelete: PenggunaanAlatReuse | null = null;
  errors: Record<string, string[]> = {};

  masterOptions: MasterAlatReuse[] = [];
  currentStatus: CanReuseResponse | null = null;

  consentList: any[] = [];
  consentLoading = false;

  metodeSterilisasiOptions = METODE_STERILISASI;

  form: any = this.emptyForm();

  headers = [
    { text: "Tanggal", value: "tanggal_penggunaan", width: 110 },
    { text: "Alat Reuse", value: "alat" },
    { text: "Ruang", value: "ruang_rawat", width: 150 },
    { text: "Jenis Operasi", value: "jenis_operasi" },
    { text: "Steril", value: "sterilisasi_sebelum_pakai", width: 70, align: "center" },
    { text: "Penggunaan Ke", value: "penggunaan_ke", width: 130, align: "center" },
    { text: "", value: "actions", sortable: false, width: 90 }
  ];

  get loading() {
    return alatReuseStore.loading;
  }

  get penggunaanList() {
    return alatReuseStore.penggunaanList;
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  get pasienRm(): string {
    return String((this.pasien && this.pasien.rm) || this.rm || "");
  }

  get statusMeta() {
    if (!this.currentStatus) return REUSE_STATUS_META.aman;
    return REUSE_STATUS_META[this.currentStatus.status] || REUSE_STATUS_META.aman;
  }

  get statusAlertType(): "success" | "warning" | "error" | "info" {
    if (!this.currentStatus) return "info";
    const s = this.currentStatus.status;
    if (s === "aman") return "success";
    if (s === "mendekati_batas") return "warning";
    return "error";
  }

  get canSubmit(): boolean {
    if (!this.form.master_alat_reuse_id) return false;
    if (!this.form.nama_pasien) return false;
    if (!this.form.tanggal_penggunaan) return false;
    if (!this.form.ruang_rawat) return false;
    if (!this.form.sterilisasi_sebelum_pakai) return false;
    if (!this.editingId && this.currentStatus && !this.currentStatus.can_reuse) return false;
    return true;
  }

  emptyForm() {
    return {
      master_alat_reuse_id: null,
      kode_unit_alat: "",
      pasien_rm: this.pasienRm,
      nama_pasien: (storePasien.identitasPasien && storePasien.identitasPasien.nama) || "",
      register_id: this.register || null,
      unit_id: null,
      tanggal_penggunaan: localISODate(),
      jenis_operasi: "",
      ruang_rawat: "",
      sterilisasi_sebelum_pakai: true,
      tanggal_sterilisasi: "",
      metode_sterilisasi: null,
      catatan: ""
    };
  }

  mounted() {
    this.loadMasterOptions();
    if (this.isActive) this.loadData();
  }

  @Watch("isActive")
  onActiveChange(active: boolean) {
    if (active) this.loadData();
  }

  @Watch("rm")
  onRmChange() {
    if (this.isActive) this.loadData();
  }

  async loadData() {
    if (!this.pasienRm) return;
    await alatReuseStore.loadPenggunaan({ pasien_rm: this.pasienRm, per_page: 100 });
  }

  async loadMasterOptions() {
    if (this.masterOptions.length) return;
    const res = await Service.masterList({ params: { per_page: 200, aktif: 1 } });
    const d = res.data.data;
    this.masterOptions = d.data || d || [];
  }

  masterItemText(item: MasterAlatReuse) {
    return `${item.kode_alat} — ${item.nama_alat} (max ${item.max_penggunaan}x)`;
  }

  async openCreate() {
    this.editingId = null;
    this.form = this.emptyForm();
    this.errors = {};
    this.currentStatus = null;
    this.consentList = [];
    if (this.masterOptions.length === 0) await this.loadMasterOptions();
    if (this.register) this.loadConsent(this.register);
    this.dialog = true;
  }

  openEdit(item: PenggunaanAlatReuse) {
    this.editingId = item.id;
    this.form = {
      master_alat_reuse_id: item.master_alat_reuse_id,
      kode_unit_alat: item.kode_unit_alat || "",
      pasien_rm: item.pasien_rm || this.pasienRm,
      nama_pasien: item.nama_pasien,
      register_id: item.register_id || this.register || null,
      unit_id: item.unit_id || null,
      tanggal_penggunaan: item.tanggal_penggunaan,
      jenis_operasi: item.jenis_operasi || "",
      ruang_rawat: item.ruang_rawat,
      sterilisasi_sebelum_pakai: !!item.sterilisasi_sebelum_pakai,
      tanggal_sterilisasi: item.tanggal_sterilisasi || "",
      metode_sterilisasi: item.metode_sterilisasi || null,
      catatan: item.catatan || ""
    };
    this.currentStatus = null;
    this.consentList = [];
    if (this.form.register_id) this.loadConsent(this.form.register_id);
    this.errors = {};
    this.dialog = true;
  }

  async onAlatChange() {
    await this.refreshStatus();
  }

  async refreshStatus() {
    if (!this.form.master_alat_reuse_id || this.editingId) return;
    try {
      this.currentStatus = await alatReuseStore.checkReuseStatus({
        masterAlatId: this.form.master_alat_reuse_id,
        kodeUnit: this.form.kode_unit_alat || undefined
      });
    } catch (e) {
      this.currentStatus = null;
    }
  }

  async loadConsent(registerId: number) {
    this.consentLoading = true;
    try {
      const resp = await http.getData(`/register/${registerId}/persetujuan-reuse`);
      this.consentList = resp.data?.data || [];
    } catch (e) {
      this.consentList = [];
    } finally {
      this.consentLoading = false;
    }
  }

  get consentStatus(): { color: string; icon: string; label: string; caption: string } {
    if (this.consentLoading) {
      return { color: "grey", icon: "mdi-loading", label: "Memeriksa persetujuan…", caption: "" };
    }
    const latest = this.consentList.length ? this.consentList[0] : null;
    if (!latest) {
      return {
        color: "warning",
        icon: "mdi-alert",
        label: "Persetujuan re-use BELUM ADA",
        caption: "Buat di Tab Persetujuan — pencatatan tetap bisa disimpan."
      };
    }
    if (latest.is_setuju === false) {
      return {
        color: "error",
        icon: "mdi-close-octagon",
        label: "Pasien MENOLAK re-use",
        caption: `No. ${latest.nomor || "-"} — periksa kembali sebelum memakai alat re-use.`
      };
    }
    const ttdLengkap = latest.signed_dpjp && latest.signed_penyetuju;
    return {
      color: ttdLengkap ? "success" : "teal",
      icon: "mdi-check-decagram",
      label: ttdLengkap ? "Persetujuan re-use ADA (TTD lengkap)" : "Persetujuan ADA (TTD belum lengkap)",
      caption: `No. ${latest.nomor || "-"}`
    };
  }

  async save() {
    this.saving = true;
    this.errors = {};
    // Pastikan identitas & register selalu dari konteks Rekam Medis
    this.form.pasien_rm = this.pasienRm;
    this.form.nama_pasien = (this.pasien && this.pasien.nama) || this.form.nama_pasien;
    if (!this.editingId) this.form.register_id = this.register || null;
    try {
      if (this.editingId) {
        await alatReuseStore.updatePenggunaan({ id: this.editingId, data: this.form });
      } else {
        await alatReuseStore.createPenggunaan(this.form);
      }
      this.dialog = false;
      await this.loadData();
    } catch (e) {
      const err = e as any;
      if (err && err.response && err.response.data && err.response.data.errors) {
        this.errors = err.response.data.errors;
      }
    } finally {
      this.saving = false;
    }
  }

  confirmDelete(item: PenggunaanAlatReuse) {
    this.toDelete = item;
    this.deleteDialog = true;
  }

  async doDelete() {
    if (!this.toDelete) return;
    this.saving = true;
    try {
      await alatReuseStore.deletePenggunaan(this.toDelete.id);
      this.deleteDialog = false;
      this.toDelete = null;
      await this.loadData();
    } finally {
      this.saving = false;
    }
  }

  formatDate(s: string) {
    if (!s) return "-";
    const d = new Date(s);
    return d.toLocaleDateString("id-ID");
  }

  usageChipColor(item: PenggunaanAlatReuse) {
    const max = (item.master && item.master.max_penggunaan) || 0;
    if (!max) return "grey";
    const ratio = item.penggunaan_ke / max;
    if (ratio >= 1) return "error";
    if (ratio >= 0.8) return "warning";
    return "success";
  }
}
